import { render } from "./StatsHeading.vue?vue&type=template&id=f5735df6"
import script from "./StatsHeading.vue?vue&type=script&lang=js"
export * from "./StatsHeading.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__